<template>
  <v-card class="my-0">
    <v-card-text>
      <v-form ref="UserCreateForm" v-model="formValid">
        <base-loader :is-loading="isLoading" />
        <v-alert v-if="successMessage" type="success">
          {{ successMessage }}
        </v-alert>
        <v-alert v-if="errorMessage" type="error">
          {{ errorMessage }}
        </v-alert>
        <v-row class="mx-1">
          <v-col cols="12" md="5">
            <v-file-input
              v-model="locationCSVFile"
              accept="text/csv"
              color="secondary"
              label="CSV File Input"
              show-size
              prepend-icon="mdi-paperclip"
              counter
              :full-width="true"
              outlined
              required
              :rules="[v => !!v || 'File is required']"
            >
              <template v-slot:selection="{ index, text }">
                <v-chip color="secondary" dark label small>
                  {{ text }}
                </v-chip>
              </template>
            </v-file-input>
            <v-btn :disabled="!locationCSVFile" color="secondary" class="ma-1" @click="stageForUploading()">
              Stage for Uploading
            </v-btn>
            <v-btn
              :disabled="!parsedCSVIsValid || parsedCSV.length === 0 || !locationCSVFile"
              class="ma-1"
              color="secondary"
              :block="false"
              @click="startUpload()"
            >
              Start Upload
            </v-btn>
            <v-progress-linear :value="uploadProgress" color="secondary" height="25" reactive class="my-5">
              <strong>{{ Math.ceil(uploadProgress) }}% ({{ completedRecords }} / {{ totalRecords }})</strong>
            </v-progress-linear>
          </v-col>
          <v-col cols="12" md="7">
            <v-textarea
              v-model="stagedTextArea"
              color="secondary"
              rows="20"
              label="Staged Data"
              filled
              no-resize
              outlined
              :readonly="true"
            />
          </v-col>
        </v-row>
      </v-form>
      <!-- <small>*indicates required field</small> -->
    </v-card-text>
    <v-card-actions>
      <!-- <v-btn
        :disabled="!locationCSVFile"
        color="secondary"
        class="mx-2"
        @click="stageForUploading()"
      >
        Save
      </v-btn> -->
    </v-card-actions>
  </v-card>
</template>

<script>
// import { mapGetters } from 'vuex'
import { gql } from 'apollo-boost';
var Papa = require('papaparse');
const Joi = require('joi');
export default {
  name: 'LocationBulkCreate',
  data: () => ({
    isLoading: false,
    uploadingData: false,
    formValid: true,
    tenant: '',
    locationCSVFile: null,
    parsedCSV: [],
    stagedTextArea: '',
    parsedCSVIsValid: false,
    uploadProgress: 0,
    totalRecords: 0,
    completedRecords: 0,
    successMessage: '',
    errorMessage: '',
  }),
  // computed: {
  //   ...mapGetters(),
  // },
  watch: {
    locationCSVFile() {
      console.log('locationCSVFile has changed');
      this.parsedCSV = [];
      this.stagedTextArea = '';
      this.parsedCSVIsValid = false;
      this.successMessage = '';
      this.errorMessage = '';
      this.uploadProgress = 0;
      this.completedRecords = 0;
      this.totalRecords = 0;
    },
  },
  async mounted() {},
  apollo: {
    me: gql`
      query {
        me {
          id
        }
      }
    `,
  },
  methods: {
    async stageForUploading() {
      const self = this;
      self.parsedCSV = [];
      this.stagedTextArea = '';
      self.isLoading = true;
      self.successMessage = '';
      self.errorMessage = '';
      try {
        console.log('Parsing CSV File');
        Papa.parse(self.locationCSVFile, {
          header: true,
          skipEmptyLines: 'greedy',
          transformHeader: header => header.trim(),
          transform: value => (typeof value === 'string' ? value.trim() : value),
          step: row => {
            console.log('Row:', row.data);
            self.parsedCSV.push(row.data);
          },
          complete: () => {
            console.log('All done!');
            self.stagedTextArea = `There are ${self.parsedCSV.length} items in this file.\r\n`;
            this.checkDataIsValid();
            self.totalRecords = self.parsedCSV.length;
            self.isLoading = false;
          },
        });
      } catch (error) {
        self.errorMessage = `Could Not Stage File: ${Date.now()} / ${error.message}`;
        self.isLoading = false;
      }
    },
    checkDataIsValid() {
      console.log('Validating Objects in Array');
      const self = this;
      self.parsedCSVIsValid = false;
      const locationObj = Joi.object().keys({
        name: Joi.string()
          .trim()
          .required()
          .messages({
            'any.required': 'Name is required',
            'string.empty': 'Name is required',
          }),
        description: Joi.string()
          .trim()
          .allow('', null),
        categoryName: Joi.string()
          .trim()
          .allow('', null),
        serviceType: Joi.string()
          .trim()
          .allow('', null),
        telephoneNumber: Joi.string()
          .trim()
          .allow('', null),
        emailAddress: Joi.string()
          .trim()
          .allow('', null),
        latitude: Joi.string()
          .trim()
          .allow('', null),
        longitude: Joi.string()
          .trim()
          .allow('', null),
        fullAddress: Joi.string()
          .trim()
          .allow('', null),
      });
      const locationArr = Joi.array().items(locationObj);
      // const test = Joi.validate(self.parsedCSV, locationArr);
      const test = locationArr.validate(self.parsedCSV, { abortEarly: false });
      console.log(test);
      if (test.error) {
        const formattedErrors = self.formatValidationErrors(test.error);
        self.errorMessage = `There are problems with your file. Please fix the rows listed below.`;
        self.stagedTextArea += `\r\nValidation errors:\r\n${formattedErrors.join('\r\n')}\r\n`;
        self.parsedCSVIsValid = false;
      } else {
        self.successMessage = 'Your file is valid';
        self.parsedCSVIsValid = true;
      }
      return self.parsedCSVIsValid;
    },
    formatValidationErrors(error) {
      const maxVisibleErrors = 25;
      const fieldLabels = {
        name: 'Name',
        description: 'Description',
        categoryName: 'Category Name',
        serviceType: 'Service Type',
        telephoneNumber: 'Telephone Number',
        emailAddress: 'Email Address',
        latitude: 'Latitude',
        longitude: 'Longitude',
        fullAddress: 'Full Address',
      };

      const formattedErrors = error.details.map(detail => {
        const rowIndex = Number.isInteger(detail.path[0]) ? detail.path[0] : null;
        const csvRowNumber = rowIndex === null ? 'unknown' : rowIndex + 2;
        const fieldName = detail.path[1] || detail.context.key || 'row';
        const fieldLabel = fieldLabels[fieldName] || fieldName;
        const message =
          detail.type === 'object.unknown'
            ? `${fieldLabel} is not a recognised column.`
            : detail.message.replace(/"[^"]+"/, fieldLabel);

        return `Row ${csvRowNumber}: ${message}`;
      });

      if (formattedErrors.length <= maxVisibleErrors) return formattedErrors;

      return [
        ...formattedErrors.slice(0, maxVisibleErrors),
        `...and ${formattedErrors.length - maxVisibleErrors} more validation errors.`,
      ];
    },
    async startUpload() {
      const self = this;
      self.totalRecords = self.parsedCSV.length;
      self.uploadProgress = 0;
      self.completedRecords = 0;
      let position = 0;
      let results = [];
      let batchSize = 100;
      let failedRecords = [];
      while (position < self.parsedCSV.length) {
        const itemsForBatch = self.parsedCSV.slice(position, position + batchSize);
        results = [
          ...results,
          ...(await Promise.all(
            itemsForBatch.map(async location => {
              console.log('Why', location);
              // location.latitude = location.latitude ? parseFloat(location.latitude.replace(',', '.')) : 0;
              // location.longitude = location.longitude ? parseFloat(location.longitude.replace(',', '.')) : 0; // Removing parseFloat for now as  server will handle it
              location.latitude = location.latitude ? location.latitude.replace(',', '.') : '';
              location.longitude = location.longitude ? location.longitude.replace(',', '.') : ''; // Removing parseFloat for now as  server will handle it
              location.createdBy = self.me.id;
              self.stagedTextArea += `${self.completedRecords}) Creating ${location.name}\r\n`;
              try {
                await self.saveLocation(location);
                self.stagedTextArea += ` ${location.name} created successfully\r\n`;
              } catch (error) {
                failedRecords.push(location.name);
                self.stagedTextArea += ` ${location.name} not created: ${error.message}\r\n`;
              }
              self.completedRecords += 1;
              self.uploadProgress = (self.completedRecords / self.totalRecords) * 100;
            })
          )),
        ];
        position += batchSize;
      }

      if (failedRecords.length > 0) {
        self.stagedTextArea += `\r\n\r\nThe following records failed to upload:\r\n`;
        failedRecords.forEach(record => {
          self.stagedTextArea += `${record}\r\n`;
        });
      }
      // await Promise.all(
      //   self.parsedCSV.map(async location => {
      //     location.latitude = parseFloat(location.latitude);
      //     location.longitude = parseFloat(location.longitude);
      //     location.createdBy = self.me.id;
      //     self.stagedTextArea += `Creating ${location.name}\r\n`;
      //     try {
      //       await self.saveLocation(location);
      //       self.stagedTextArea += ` ${location.name} created successfully\r\n`;
      //     } catch (error) {
      //       self.stagedTextArea += ` ${location.name} not created: ${error.message}\r\n`;
      //     }
      //     self.completedRecords += 1;
      //     self.uploadProgress = (self.completedRecords / self.totalRecords) * 100;
      //   })
      // );
      self.$eventHub.$emit('refresh-invetory-item-view');
    },
    async saveLocation(locationObj) {
      const self = this;
      self.successMessage = '';
      self.errorMessage = '';
      try {
        console.log('locationObj', locationObj);
        const createdLocation = await this.$apollo.mutate({
          mutation: gql`
            mutation($locationInput: LocationCreateByRefInput!) {
              createLocationByRefs(location: $locationInput) {
                id
              }
            }
          `,
          variables: { locationInput: locationObj },
          error(error) {
            console.log(JSON.stringify(error.message));
          },
        });
        console.log(createdLocation);
        return true;
      } catch (error) {
        throw error;
      }
    },
  },
};
</script>

<style lang="sass"></style>
